/**
 * @file aside-fields.ts
 * @description Классы блока полей панели документа (phase19.24 этап 1, шаг 1).
 *
 * На `<lg` панель свёрнута до поля скана: остальные поля появляются только
 * после выбора фасовки, иначе список позиций уезжал бы на второй экран
 * (решение пользователя 2026-09-20). Правило одно на приёмку, списание и
 * перемещение — держим его в одном месте, а не тремя одинаковыми строками
 * классов в трёх формах.
 *
 * Отдельный модуль, а не экспорт из `DocumentAside.tsx`: файл с компонентом,
 * экспортирующий ещё и функцию, ломает Fast Refresh (правило eslint).
 */

/** `open` — фасовка выбрана: поля строки видны и на телефоне. */
export function asideFieldsClass(open: boolean): string {
  return open ? "flex flex-col gap-3" : "hidden lg:flex lg:flex-col lg:gap-3";
}
